import React, {useEffect} from "react";
import axios from "axios";
import FileEntity, {STATUS_FAILURE, STATUS_SUCCESS} from "../helpers/FileEntity";
import {useDispatch, useSelector} from "react-redux";
import {addFile, clearFiles, updateFile} from "../actions/FileActions";
import {extensionByName} from "../../../../common/helpers/FileExtention";
import {bytesToSize} from "../../../../common/helpers/FileHelper";

function useUploadFile(options, refreshState = true) {
    const dispatch = useDispatch();
    const storageFiles = useSelector(state => state.file.data);
    let count = storageFiles.length;

    useEffect(() => {
        if (refreshState) {
            dispatch(clearFiles());
        }
    }, []);

    useEffect(() => {
        count = storageFiles.length;
    }, [storageFiles]);

    const validateLimit = () => new Promise((resolve, reject) => {
        if (count >= options.limit) {
            reject('Limit reached');
        }

        ++count;
        resolve();
    })

    const validateExists = (file) => new Promise((resolve, reject) => {
        storageFiles.map(storageFile => {
            if (JSON.stringify(storageFile.source) === JSON.stringify(file.source)) {
                reject('Your file already uploaded')
            }
        })

        resolve();
    })

    const validateFile = file => new Promise((resolve, reject) => {
        const fileExtension = extensionByName(file.source.name)
        const fileSize = file.source.size

        if (fileSize === options.sizeMin) {
            reject('File is empty');
        }
        else if (fileSize > options.sizeMax) {
            reject(`This file is too large, please upload a file under ${bytesToSize(options.sizeMax)}`);
        }
        else if (fileExtension === '') {
            reject('Your file format is empty');
        }
        else if (!options.extensions.includes(fileExtension)) {
            reject('Unsupported file format');
        } else {
            resolve();
        }

    })

    const uploadToServer = file => new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('file', file.source);

        axios.post('/api/file', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            if (res.data.errors.length) {
                reject(res.data.errors.length[0]);
            }

            resolve(res.data.name);
        }).catch(error => {
                console.log(error);
                reject(error.response?.data?.errors?.detail || error.message || 'Upload failed');
            }
        );
    })

    const uploadFile = (source) => {
        const file = new FileEntity(source);

        dispatch(addFile(file));

        validateLimit().then(() => {
            return validateFile(file);
        }).then(() => {
            return validateExists(file);
        }).then(() => {
            return uploadToServer(file);
        }).then(name => {
            file.status = STATUS_SUCCESS;
            file.name = name;
            dispatch(updateFile(file));
        }).catch(message => {
            file.status = STATUS_FAILURE;
            file.message = message;
            dispatch(updateFile(file));
        });
    };

    const uploadFiles = sources => {
        sources.map(source => {
            setTimeout(() => {
                uploadFile(source)
            }, 10)
        });
    }

    return {
        uploadFile: uploadFile,
        uploadFiles: uploadFiles,
    }
}

export default useUploadFile